import React from "react";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import LoginPage from "../Pages/LoginPage";
import DailyRevenuePage from "../Pages/DailyRevenuePage";
import MonthlyRevenuePage from "../Pages/MonthlyRevenuePage";
import AddCountryAndOperatorPage from "../Pages/AddCountryAndOperatorPage";
import PublisherTrafficPage from "../Pages/PublisherTrafficPage";
import PublisherSubscriptionPage from "../Pages/PublisherSubscriptionPage";
import DashboardPage from "../Pages/DashboardPage";
import ServicePage from "../Pages/ServicePage";
import AdvertiserPage from "../Pages/AdvertiserPage";
import AdvertiserTrafficPage from "../Pages/AdvertiserTrafficPage";
import AdvertiserSubscriptionPage from "../Pages/AdvertiserSubscriptionPage";
import DailyRevenueAdminPage from "../Pages/DailyRevenueAdminPage";
import DashboardAdminPage from "../Pages/DashboardAdminPage";
import MonthlyRevenueAdminPage from "../Pages/MonthlyRevenueAdminPage";
import ErrorBoundary from "../Pages/ErrorBoundary";
import Auth from "../NewComponents/Auth/Auth";
import UploadVideo from "../Pages/UploadVideo";
import ServiceAdministration from "../Pages/AdminPages/ServiceAdministration";
import ServiceAdministration2 from "../Pages/AdminPages/ServiceAdministration2";
import LiveData from "../Pages/LiveData";

// DEFINING THE ROUTES OF THE PAGES... AND ALSO PROTECTED SOME PAGES USING AUTH COMPONENT
const router = createBrowserRouter([
  {
    path: "/",
    element: <LoginPage />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/dailyRevenue",
    element: (
      // through login api , we are getting the hide_data information , and that we are storing in localStorage and if hide_data is true then we will protect this page..
      <Auth conditionApply={true} condition={localStorage.getItem("hide_data")}>
        <DailyRevenuePage />
      </Auth>
    ),
    errorElement: <ErrorBoundary />,
  },
  { 
    path:"/live-data",
    element:(
      <Auth conditionApply={true} condition={localStorage.getItem("hide_data")}>
      <LiveData />
    </Auth>
    )
  },
  {
    path: "/monthlyRevenue",
    element: (
      <Auth conditionApply={true} condition={localStorage.getItem("hide_data")}>
        <MonthlyRevenuePage />
      </Auth>
    ),
    errorElement: <ErrorBoundary />,
  },
  // if the username is etho_1234 or hide_data is true , then we will protect the dashboard page..
  {
    path: "/dashboard",
    element: (
      <Auth
        conditionApply={true}
        condition={
          localStorage.getItem("hide_data") ||
          localStorage.getItem("userName") == "etho_1234"
        }
      >
        <DashboardPage />
      </Auth>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/dashboard/:serviceName/:id",
    element: (
      <Auth
        conditionApply={true}
        condition={
          localStorage.getItem("hide_data") ||
          localStorage.getItem("userName") == "etho_1234"
        }
      >
        <ServicePage />
      </Auth>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/add-country-and-add-operator",
    element: (
      <Auth
        conditionApply={true}
        condition={
          localStorage.getItem("hide_data") ||
          localStorage.getItem("userName") == "etho_1234"
        }
      >
        <AddCountryAndOperatorPage />
      </Auth>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/publisher-traffic",
    element: (
      <Auth
        conditionApply={true}
        condition={localStorage.getItem("userName") == "etho_1234"}
      >
        <PublisherTrafficPage />
      </Auth>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/publisher-subscription",
    element: (
      <Auth
        conditionApply={true}
        condition={localStorage.getItem("userName") == "etho_1234"}
      >
        <PublisherSubscriptionPage />
      </Auth>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/advertiser",
    element: <AdvertiserPage />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/advertiser-traffic",
    element: <AdvertiserTrafficPage />,

    errorElement: <ErrorBoundary />,
  },
  {
    path: "/advertiser-subscription",
    element: <AdvertiserSubscriptionPage />,
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/dailyRevenueAdmin",
    element: (
      <Auth admin={true}>
        <DailyRevenueAdminPage />
      </Auth>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/monthlyRevenueAdmin",
    element: (
      <Auth admin={true}>
        <MonthlyRevenueAdminPage />
      </Auth>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/dashboardAdmin",
    element: (
      <Auth admin={true}>
        <DashboardAdminPage />
      </Auth>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/uploadFlowVideo",
    element: (
      <Auth admin={true}>
        <UploadVideo />
      </Auth>
    ),
    errorElement: <ErrorBoundary />,
  },
  {
    path: "/service/administration",
    element: (
      <Auth admin={true}>
        <ServiceAdministration2 />
      </Auth>
    ),
  },
  {
    path: "/service/administration2",
    element: (
      <Auth admin={true}>
        <ServiceAdministration />
      </Auth>
    ),
  },
]);

const Routing = () => {
  return <RouterProvider router={router} />;
};

export default Routing;
